export default __webpack_public_path__ + "static/media/featSportMb.c699e30f.png";